var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperimentExpiredHits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12537_14379)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9762 10.6957C19.9581 10.9595 19.9297 11.2205 19.8915 11.4783H24V6H19.1679C19.2795 6.25548 19.3808 6.51653 19.4712 6.78261H23.2174V10.6957H19.9762ZM18.5217 15.2353V17.7391H24V12.2609H19.7434C19.6821 12.5259 19.6103 12.787 19.5284 13.0435H23.2174V16.9565H19.3043V13.6719C19.0886 14.2182 18.8261 14.741 18.5217 15.2353ZM16.3334 17.7391C16.8471 17.3182 17.3182 16.8471 17.7391 16.3334V17.7391H16.3334ZM12.2609 19.7434V24H17.7391V18.5217H15.2353C14.741 18.8261 14.2182 19.0886 13.6719 19.3043H16.9565V23.2174H13.0435V19.5284C12.787 19.6103 12.5259 19.6821 12.2609 19.7434ZM6 19.1679V24H11.4783V19.8915C11.2205 19.9297 10.9595 19.9581 10.6957 19.9762V23.2174H6.78261V19.4712C6.51653 19.3808 6.25548 19.2795 6 19.1679ZM18.5217 18.5217H24V24H18.5217V18.5217ZM19.3043 19.3043H23.2174V23.2174H19.3043V19.3043Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "#FEFEFE",
    stroke: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1649 3L14.4236 7.05475L11.8355 8.38608L9.94532 5.82868L13.1649 3ZM9.86019 6.0144L11.709 8.51591L10.8122 11.5721L10.1511 7.39771L10.1415 7.33747L10.0953 7.29601L9.86547 7.08973L9.82009 6.11725L9.86019 6.0144ZM11.3172 13.0121L11.3295 13.021L12.4599 9.8311L11.3172 13.0121ZM12.462 9.82821L13.7726 9.042L13.7782 9.02863L12.462 9.82821ZM10.6508 11.7092L10.6178 11.7628L10.0627 11.3157L9.87709 7.33884L9.97218 7.42417L10.6508 11.7092ZM11.1652 12.9019L11.1485 12.8898L10.9223 12.5837L10.8783 11.988L11.8845 8.559L14.3503 7.29058L13.8906 8.75379L12.3643 9.68098L12.3105 9.71367L12.2896 9.7717L11.1652 12.9019Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4619 9.82816L13.7726 9.04195L13.7782 9.02858L12.4619 9.82816ZM11.1641 12.9049L11.1485 12.8898L10.9222 12.5837L10.8782 11.9879L11.8844 8.55895L14.3503 7.29053L13.8905 8.75374L12.3642 9.68093L12.3104 9.71362L12.2896 9.77165L11.1641 12.9049Z",
    fill: "#0059CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1649 3L14.4236 7.05475L11.8355 8.38608L9.94532 5.82868L13.1649 3Z",
    fill: "#5CA2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60529 8.42961L6.58019 4.47224L8.78963 12.2488L8.70533 12.3652L7.52899 9.17327L5.60529 8.42961ZM10.7618 12.375L9.65543 11.0535L8.92442 12.0627L6.7494 4.40723L9.97291 7.44164L10.7618 12.375Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60529 8.42954L6.58019 4.47217L8.61421 11.6313L8.70533 12.3651L7.52899 9.1732L5.60529 8.42954Z",
    fill: "#0059CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8234 16.7341L14.3929 15.9969L15.3413 14.5893L12.339 16.1401L11.8234 16.7341ZM12.6024 15.8058L15.1561 14.4867L13.5804 14.6016L12.7896 15.557L12.6024 15.8058Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4624 16.1402L15.4647 14.5894L14.5163 15.997L11.9468 16.7342L12.4624 16.1402Z",
    fill: "#0059CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49517 16.4394L4.36194 14.6644L7.555 16.0925L7.75522 16.3441L7.98144 16.5627L8.4114 16.9782L5.49517 16.4394ZM6.15844 14.342L7.30278 15.7757L7.3168 15.7933L4.46205 14.5165L6.15844 14.342Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49517 16.3433L4.36194 14.5684L7.555 15.9965L7.75522 16.248L7.98144 16.4666L8.4114 16.8822L5.49517 16.3433ZM7.11586 15.6073L7.30278 15.6796L7.3168 15.6972L7.11586 15.6073Z",
    fill: "#0059CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7023 7.86523L15.867 11.6449L13.2178 11.9649L12.4833 9.83559L12.4908 9.815L15.7023 7.86523ZM12.3855 10.105L13.058 12.0547L11.2395 15.7264L11.4652 13.4146L11.3295 13.0211L11.3482 12.9621L12.3855 10.105ZM11.5749 17.0001L11.1032 17L11.1843 16.2431L13.2157 12.1414L15.7189 11.839L11.5749 17.0001Z",
    fill: "#5CA2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3856 10.1051L13.058 12.0547L11.2396 15.7265L11.4652 13.4146L11.3295 13.0211L11.3481 12.9625L12.3856 10.1051Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5749 16.9999L11.1032 16.9999L11.1444 16.3235L13.2157 12.1413L15.7189 11.8389L11.5749 16.9999Z",
    fill: "#0059CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56525 11.8458L7.44039 9.50127L8.46369 12.2703L8.56961 12.5838L8.16241 13.2397L8.56961 14.8138L9.17668 16.4436L6.56525 11.8458ZM7.66268 16.0131L8.51897 16.9793L9.27456 16.9794L6.41342 11.9419L4.10222 11.9955L4.77475 12.7543L6.26218 14.2017L7.66268 16.0131ZM4 11.8229L6.40217 11.7672L7.32597 9.29238L4.00001 8.01343L4 11.8229Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51897 16.9793L9.27456 16.9794L6.41342 11.9419L4.10222 11.9955L4.77475 12.7543L6.26218 14.2017L7.66268 16.0131L8.51897 16.9793ZM4 11.8229L6.40217 11.7672L7.32597 9.29238L4.00001 8.01343L4 11.8229Z",
    fill: "#5CA2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51896 16.9793L9.27454 16.9793L6.41341 11.9419L4.1022 11.9954L4.7747 12.7543L6.26217 14.2016L7.66271 16.0131L8.51896 16.9793Z",
    fill: "#0059CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9798 16.9693L11.3241 13.6257L9.99516 14.7967L10.2984 16.9724L10.9798 16.9693ZM10.1158 16.9723L9.81384 14.8059L8.40527 13.555L9.45536 16.9692L10.1158 16.9723ZM9.89939 14.6444L8.34338 13.2625L9.66486 11.3467L11.3147 13.3973L9.89939 14.6444Z",
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1158 16.9723L9.81384 14.8059L8.40527 13.555L9.45536 16.9692L10.1158 16.9723ZM9.89939 14.6444L8.34338 13.2625L9.66486 11.3467L11.3147 13.3973L9.89939 14.6444Z",
    fill: "#5CA2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1158 16.9723L9.81385 14.8059L8.40527 13.5549L9.45536 16.9692L10.1158 16.9723Z",
    fill: "#0059CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12537_14379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperimentExpiredHits);
export default __webpack_public_path__ + "static/media/Experiment_Expired_Hits.427dc54520b282ac208530ab79a482e1.svg";
export { ForwardRef as ReactComponent };